import { useCallback, useContext, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { StationContext } from '@/pages/station-context'
import { Select } from '@mantine/core'

export const StationSelect = () => {
  const { station, allowedStations, isLoading } = useContext(StationContext)

  const stationOptions = useMemo(
    () =>
      Object.values(allowedStations || []).map((station) => ({
        value: station.recordNumber,
        label: `${station.brand} (${station.recordNumber})`,
      })),
    [allowedStations]
  )

  const navigate = useNavigate()
  const { pathname } = useLocation()

  // It'd be nice to be able to use an explicit navigation function here, but we don't
  // really know exactly what page this component is on, so we have to use the pathname
  // to determine the correct path to navigate to by switching out the station record number
  // in the URL
  const navigateToStationPage = useCallback(
    (stationRecordNumber: string) => {
      if (!stationRecordNumber) return

      const path = pathname.split('/')
      path[2] = stationRecordNumber
      navigate(path.join('/'))
    },
    [navigate, pathname]
  )

  return (
    <Select
      aria-label='Select station'
      data={stationOptions}
      value={station?.recordNumber}
      allowDeselect={false}
      onChange={(value: string | null) => {
        navigateToStationPage(value || '')
      }}
      disabled={isLoading}
      width='100%'
    />
  )
}
